import { HibooIcon } from 'modules/design-system';
import { AuthBaseCardHeaderCSS } from './AuthBaseCardHeader.css';

const { Container, Title } = AuthBaseCardHeaderCSS;

type Props = {
  title: string;
};

export const AuthBaseCardHeader = ({ title }: Props) => {
  return (
    <Container>
      <HibooIcon />
      <Title>{title}</Title>
    </Container>
  );
};
